/**
 *
 * Home
 *
 */

import React from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import collect from "collect.js"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import ModalCustom from "components/ModalCustom"
import Layout from "components/Layout"
import { Button, Input, Select, Spin, Tooltip } from "antd"
import { Icon } from "@ant-design/compatible"
import { debounce, isEqual } from "lodash"
import {
  makeSelectCompaniesAccessLoading,
  makeSelectIsLoading,
  makeSelectOptions,
  makeSelectSaveLoading,
  makeSelectUserCreate,
  makeSelectUsers,
} from "./selectors"
import {
  deleteCompaniesUserAccessManduWatcher,
  deleteUserWatcher,
  getOptionsWatcher,
  getUserCreateManduWatcher,
  getUsersManduWatcher,
  recoveryPasswordWatcher,
  saveCompanyUserAccessManduWatcher,
  saveUserWatcher,
  userChangeRoleWatcher,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import ManduUsersTable from "../../../../components/ManduUsersTable"
import ManduUsersDrawer from "../../../../components/ManduUsersDrawer"
import "./index.less"
import alertSvg from "../../../../images/alert.svg"
import {
  ROLE_MANDU_ADMIN,
  ROLE_MANDU_SUPER_ADMIN,
} from "../../../../utils/constants"
import {
  CloseCircleOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class Home extends React.Component {
  state = {
    searchHistoryMeasurement: "",
    selectedService: undefined,
    selectedModule: undefined,
    userSelected: {},
    formVisible: false,
    modalUserDelete: false,
    modalUserRole: false,
    isFilter: false,
  }

  componentDidMount() {
    this.props.getOptions()
    this.props.getUsersMandu()
    this.props.getUserCreateMandu()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.users, this.props.users)) {
      this.setState({ formVisible: false }, () =>
        this.setState({ userSelected: {} })
      )
    }
  }

  showDataBySearch = () =>
    Array.isArray(this.props.users) ? this.props.users : []

  saveSubmitSaveCompanyUserAccess = (item) => {
    if (item.id != null) {
      this.setState({ changes: true })
      this.props.saveCompanyUserAccess(item)
    }
  }

  deleteSubmitCompaniesUserAccess = (item) => {
    if (item.id != null) {
      this.setState({ changes: true })
      this.props.deleteCompaniesUserAccess(item)
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  pressFilter = () => {
    this.setState({ isFilter: true })
    const {
      searchHistoryMeasurement,
      selectedService = "",
      selectedModule = "",
    } = this.state
    this.props.getUsersMandu({
      searchHistoryMeasurement,
      selectedService,
      selectedModule,
    })
  }

  searchWithDebounce = debounce(() => {
    this.pressFilter()
  }, 500)

  reloadAfterCloseDrawer = (isNew, tab) => {
    if (isNew === false && tab === "1") {
      const { changes } = this.state
      if (changes != null) {
        this.setState({ changes: null })
        this.props.getUsersMandu()
      }
    }
    this.setState({ formVisible: false })
  }

  reSetAttributeCollectCompanyUserAccess = (data) => {
    const collection = collect(data.companiesUserAccesses)
    let itemsRename = []

    if (collection.count() > 0) {
      itemsRename = collection
        .map((item) => ({ id_company: item.id_company }))
        .toArray()
    }

    return itemsRename
  }

  dataTransformFormDataWhenUploadPicture = (itemsFromForm, dataSend) => {
    if (typeof itemsFromForm.picture_profile === "object") {
      const fd = new FormData()
      fd.append("profile_picture", itemsFromForm.picture_profile)
      collect(dataSend).each((item, key) => {
        fd.append(key, dataSend[key])
      })

      return fd
    }
    return dataSend
  }

  dataSetUseAttributesTransform = (itemsUnserialize, itemsRename) => {
    const newItem = {
      email: itemsUnserialize.email,
      first_name: itemsUnserialize.first_name || "",
      id_gender: 3,
      id_role: itemsUnserialize.id_role,
      last_name: itemsUnserialize.last_name || "",
      second_last_name: itemsUnserialize.second_last_name || "",
      support: itemsUnserialize.support || false,
    }

    if (itemsUnserialize.id) newItem.id = itemsUnserialize.id

    if (itemsUnserialize.id == null)
      newItem.companies_user_accesses = JSON.stringify(itemsRename)

    return newItem
  }

  pressSave = async (itemsFromForm) => {
    const itemsUnserialize = JSON.parse(JSON.stringify(itemsFromForm))
    let dataSend = null
    const itemsRename = this.reSetAttributeCollectCompanyUserAccess(
      itemsUnserialize
    )

    await this.setState({ userSelected: itemsUnserialize })

    dataSend = this.dataSetUseAttributesTransform(itemsUnserialize, itemsRename)

    dataSend = this.dataTransformFormDataWhenUploadPicture(
      itemsFromForm,
      dataSend
    )

    this.props.saveUser(dataSend)
  }

  getDataFromRow = (e) => {
    ;(async () => {
      e.companiesUserAccesses = e.companies_access
      await this.setState({ userSelected: e, formVisible: true })
    })()
  }

  recoveryPassword = (e) => {
    this.props.recoveryPassword({ email: e.email })
  }

  render() {
    const {
      searchHistoryMeasurement,
      formVisible,
      userSelected,
      modalUserDelete,
      modalUserRole,
      isFilter,
    } = this.state
    const {
      options,
      isLoading,
      users,
      save_loading,
      userCreate,
      companiesAccessLoading,
    } = this.props
    return (
      <Layout>
        <Helmet>
          <title>Administradores Mandü</title>
          <meta name="description" content="Description of Home" />
        </Helmet>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 60,
          }}>
          <div className="AdministratorUsersHome" style={{ height: "100%" }}>
            <div className="AdministratorUsersHome-header">
              <div className="AdministratorUsersHome-header-title">
                <span>
                  Usuarios administradores Mandü{" "}
                  <span className="color-gray-low" style={{ fontWeight: 400 }}>
                    ({this.showDataBySearch().length})
                  </span>
                </span>
              </div>
              <div className="AdministratorUsersHome-header-buttons">
                <Tooltip
                  placement="bottomRight"
                  title="Crear administrador Mandü">
                  <Button
                    className="blueButton"
                    size="default"
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() =>
                      this.setState({ formVisible: true, userSelected: {} })
                    }
                  />
                </Tooltip>
              </div>
            </div>

            <div className="AdministratorUsersHome-body">
              <div className="AdministratorUsersHome-body-filters">
                <Input
                  placeholder="Buscar..."
                  style={{ width: 300 }}
                  value={searchHistoryMeasurement}
                  onChange={(e) =>
                    this.setState(
                      { searchHistoryMeasurement: e.target.value },
                      () => this.searchWithDebounce()
                    )
                  }
                  suffix={
                    searchHistoryMeasurement ? (
                      <CloseCircleOutlined
                        style={{
                          cursor: "pointer",
                          color: "white",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "50%",
                        }}
                        onClick={(e) =>
                          this.setState({ searchHistoryMeasurement: "" }, () =>
                            this.pressFilter()
                          )
                        }
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                />
                <div className="AdministratorUsersHome-body-filters-right">
                  <Select
                    allowClear
                    onChange={(e) =>
                      this.setState({ selectedModule: e }, () =>
                        this.pressFilter()
                      )
                    }
                    placeholder="Seleccionar módulo"
                    style={{ width: 200, marginRight: "1rem" }}>
                    {options &&
                      options.PlatformHasModules &&
                      options.PlatformHasModules.map((mM, mMI) => (
                        <Option key={mMI} value={mM.id_platform}>
                          {mM.name}
                        </Option>
                      ))}
                  </Select>
                  <Select
                    allowClear
                    onChange={(e) =>
                      this.setState({ selectedService: e }, () =>
                        this.pressFilter()
                      )
                    }
                    placeholder="Seleccionar tipo"
                    style={{ width: 200 }}>
                    <Option value={3}>Superadministrador</Option>
                    <Option value={4}>Administrador</Option>
                  </Select>
                </div>
              </div>
              <div className="AdministratorUsersHome-body-content">
                {!isFilter && isLoading ? (
                  <div className="loadingSpin">
                    <Spin size="large" />
                  </div>
                ) : (
                  <ManduUsersTable
                    userSelected={(e) => this.getDataFromRow(e)}
                    isLoading={isLoading}
                    users={this.showDataBySearch()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ManduUsersDrawer
          recoveryPassword={(e) => this.recoveryPassword(e)}
          pressSave={(e) => this.pressSave(e)}
          userSelected={userSelected}
          userCreate={userCreate}
          companiesAccessLoading={companiesAccessLoading}
          save_loading={save_loading}
          saveSubmitSaveCompanyUserAccess={(e) =>
            this.saveSubmitSaveCompanyUserAccess(e)
          }
          deleteSubmitCompaniesUserAccess={(e) =>
            this.deleteSubmitCompaniesUserAccess(e)
          }
          hide={(isNew, Tab) => this.reloadAfterCloseDrawer(isNew, Tab)}
          visible={formVisible}
          deleteUser={(e) => this.setState({ modalUserDelete: true })}
          changeRoleUser={(e) => this.setState({ modalUserRole: true })}
        />
        <ModalDeleteSimple
          visible={modalUserDelete}
          content={<p>¿Estás seguro de que deseas eliminar al usuario?</p>}
          onOk={() => {
            this.props.deleteUser({ user_id: userSelected.id })
            this.setState({ modalUserDelete: false })
          }}
          onCancel={() => {
            this.setState({ modalUserDelete: false })
          }}
        />

        <ModalCustom
          modalOpen={modalUserRole}
          showFooter
          textButton="Convertir"
          onOk={() => {
            this.props.userChangeRole({
              id: userSelected.id,
              id_role:
                userSelected.id_role == ROLE_MANDU_SUPER_ADMIN
                  ? ROLE_MANDU_ADMIN
                  : ROLE_MANDU_SUPER_ADMIN,
            })
            this.setState({ modalUserRole: false })
          }}
          onCancel={() => {
            this.setState({ modalUserRole: false })
          }}>
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              {userSelected.id_role == ROLE_MANDU_SUPER_ADMIN ? (
                <p>
                  ¿Estás seguro de que deseas convertir al usuario{" "}
                  <b>
                    {userSelected.first_name} {userSelected.last_name}
                  </b>{" "}
                  en administrador? <br />
                  Perderá los permisos adicionales con los que cuenta
                  actualmente al ser un superadministrador.
                </p>
              ) : (
                <p>
                  ¿Estás seguro de que deseas convertir al usuario{" "}
                  <b>
                    {userSelected.first_name} {userSelected.last_name}
                  </b>{" "}
                  en superadministrador?{" "}
                </p>
              )}
            </div>
          </div>
        </ModalCustom>
      </Layout>
    )
  }
}

Home.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  users: makeSelectUsers(),
  userCreate: makeSelectUserCreate(),
  save_loading: makeSelectSaveLoading(),
  options: makeSelectOptions(),
  companiesAccessLoading: makeSelectCompaniesAccessLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getUserCreateMandu: (params) => dispatch(getUserCreateManduWatcher(params)),
    getUsersMandu: (params) => dispatch(getUsersManduWatcher(params)),
    deleteUser: (params) => dispatch(deleteUserWatcher(params)),
    saveUser: (params) => dispatch(saveUserWatcher(params)),
    recoveryPassword: (params) => dispatch(recoveryPasswordWatcher(params)),
    getOptions: (params) => dispatch(getOptionsWatcher(params)),
    userChangeRole: (params) => dispatch(userChangeRoleWatcher(params)),
    saveCompanyUserAccess: (params) =>
      dispatch(saveCompanyUserAccessManduWatcher(params)),
    deleteCompaniesUserAccess: (params) =>
      dispatch(deleteCompaniesUserAccessManduWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "AdministratorUsersHome", reducer })
const withSaga = injectSaga({ key: "AdministratorUsersHome", saga })

export default compose(withReducer, withSaga, withConnect)(Home)
